/* eslint-disable import/prefer-default-export */
/**
 * 전달받은 값이 빈 값일 경우 true, 그렇지 않을 경우 false를 반환한다.
 * 다음 중 하나인 경우 빈 값으로 판단한다.
 * 1) null
 * 2) undefined
 * 3) 길이가 0인 배열
 * 4) 길이가 0인 문자열 (만약 allowEmptyString가 true가 아닐 경우)
 * @author Ju
 * @param  {[type]}  value            [description]
 * @param  {[type]}  allowEmptyString [description]
 * @return {Boolean}                  [description]
 */
export function isEmpty(value, allowEmptyString) {
  // reference ExtJs
  return value === null || value === undefined || (!allowEmptyString ? value === '' : false) || (Array.isArray(value) && value.length === 0);
}

/**
 * 16진수 색상 코드(Hex)를 전달 받은 투명도에 따라 rgba 값으로 변환한다.
 * 해당 functuon이 이벤트 등급 셀 영역 이외에 활용이 필요할 경우 utils로 분리하도록 한다.
 *
 * @author Ju
 * @param  {String} hex     16진수 색상 코드 (hex)
 * @param  {Number} opacity 투명도 (백분율 0~100)
 * @return {String}         rgba 값
 */
export function convertHex2Rgba(hex, opacity) {
  let opacityValue;
  if (isEmpty(opacity)) {
    opacityValue = 1;
  } else {
    opacityValue = (opacity < 1) ? opacity : (opacity / 100);
  }

  const hexCode = hex.replace('#', '');
  const r = parseInt(hexCode.substring(0, 2), 16);
  const g = parseInt(hexCode.substring(2, 4), 16);
  const b = parseInt(hexCode.substring(4, 6), 16);

  return `rgba(${r},${g},${b},${opacityValue})`;
}



// WEBPACK FOOTER //
// ./src/utils/basic.js